//$.mobileBackCompat = true;
jQuery(document).on('mobileinit',function(){
$.mobile.pageContainer = $("#swiper_Frame");


  $.mobile.loader.prototype.options.text = "<div class='sk-three-bounce'><div class='sk-child sk-bounce1'></div><div class='sk-child sk-bounce2'></div><div class='sk-child sk-bounce3'></div></div>";

  $(function(){ 
   
   $( "#header" ).toolbar();
   $( "#frequently-bought-popups .popupwrap" ).enhanceWithin().popup();
  $( "#shopify-section-Policy-Terms .popupwrap" ).enhanceWithin().popup({
  afteropen: function( event, ui ) {
    $('body').addClass('popopen');
  },
  afterclose: function( event, ui ) {
     $('body').removeClass('popopen');
  }
});
    
    
    
    // add vs
    $('#screen').prepend('<div id="popup" class="popup"><div class="popup-inner"> <div class="close" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"width="50" height="50"viewBox="0 0 50 50"style="fill:#fff;"><g id="surface1"><path style=" " d="M 14.40625 13 L 13 14.40625 L 23.625 25 L 13 35.59375 L 14.40625 37 L 25.0625 26.40625 L 35.6875 37 L 37.09375 35.59375 L 26.46875 25 L 37.09375 14.40625 L 35.6875 13 L 25.0625 23.59375 Z "></path></g></svg> </div> <div id="progress-bars-wrap"></div> <div id="NavLeft" class="control left"></div> <div id="NavRight" class="control right"></div> <div class="story-profile"> <div class="story-profile-pic"> <div> </div> </div> <div class="story-profile-content"> </div></div> <div id="swipe" style="opacity:0;"><div class="arrows"><svg width="669pt" height="1151pt" viewBox="0 0 669 1151" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="arrow1" opacity="1" transform="translate(0,0)"><path fill="#ffffff" opacity="1" d=" M 323.44 179.52 C 332.65 174.88 344.63 176.71 351.95 184.01 C 454.69 285.94 557.42 387.89 660.15 489.82 C 667.74 496.79 670.18 508.61 666.01 518.02 C 664.40 522.06 661.41 525.31 658.30 528.27 C 645.11 541.42 631.97 554.63 618.77 567.77 C 609.61 576.78 593.46 576.71 584.35 567.64 C 501.06 485.17 417.76 402.71 334.51 320.19 C 251.25 402.68 167.96 485.15 84.67 567.62 C 75.57 576.71 59.39 576.79 50.22 567.76 C 36.04 553.61 21.86 539.45 7.72 525.26 C -1.47 515.92 -1.17 499.36 8.33 490.35 C 108.70 390.71 209.12 291.13 309.49 191.49 C 314.05 187.41 317.77 182.18 323.44 179.52 Z" /></g><g id="arrow2" opacity="1" transform="translate(0,0)"> <path fill="#ffffff" opacity="1" d=" M 316.30 585.25 C 319.46 581.99 323.46 579.50 327.87 578.35 C 335.44 577.33 343.93 577.47 350.00 582.81 C 358.67 590.85 366.83 599.43 375.31 607.68 C 469.85 701.50 564.40 795.31 658.95 889.12 C 662.07 892.02 664.83 895.43 666.32 899.47 C 669.86 908.36 667.78 919.21 661.03 926.02 C 646.86 940.19 632.72 954.38 618.52 968.51 C 608.85 977.78 591.92 976.94 583.08 966.91 C 500.25 884.82 417.33 802.80 334.51 720.69 C 251.34 803.09 168.13 885.46 84.95 967.85 C 75.46 977.68 58.02 977.26 48.96 967.05 C 35.17 953.18 21.27 939.41 7.50 925.52 C -1.37 916.24 -1.11 900.10 8.07 891.12 C 110.78 789.13 213.56 687.21 316.30 585.25 Z" /></g> <animateTransform attributeName="transform"type="translate"from="0 0"to="0 -200"dur="1.4s"values="0 0 ; 0 -200 ; 0 200 ; 0 0 ; 0 0" keyTimes="0; 0.35; 0.364; 0.77; 1" repeatCount="indefinite"xlink:href="#arrow1" /> <animateTransform attributeName="transform"type="scale"from="1"to="1"dur="1.4s"values="1 ; 0.9 ; 0.9 ; 1 ; 1" keyTimes="0; 0.35; 0.364; 0.77; 1" repeatCount="indefinite"xlink:href="#arrow1" additive="sum" /> <animate attributeType="CSS" attributeName="opacity"from="1"to="0"dur="1.4s"values="1 ; 0 ; 0 ; 1 ; 1" keyTimes="0; 0.35; 0.364; 0.77; 1" repeatCount="indefinite"xlink:href="#arrow1" /> <animateTransform attributeName="transform"type="translate"from="0 0"to="0 -200"dur="1.4s"begin="0.2s" values="0 0 ; 0 -200 ; 0 200 ; 0 0 ; 0 0" keyTimes="0; 0.35; 0.364; 0.77; 1" repeatCount="indefinite"xlink:href="#arrow2" /> <animateTransform attributeName="transform"type="scale"from="1"to="1"dur="1.4s"begin="0.2s" values="1 ; 0.9 ; 0.9 ; 1 ; 1" keyTimes="0; 0.35; 0.364; 0.77; 1" repeatCount="indefinite"xlink:href="#arrow2" additive="sum" /> <animate attributeType="CSS" attributeName="opacity"from="1"to="0"dur="1.4s"begin="0.2s" values="1 ; 0 ; 0 ; 1 ; 1" keyTimes="0; 0.35; 0.364; 0.77; 1" repeatCount="indefinite"xlink:href="#arrow2" /> </svg> </div> Swipe up to view </div><div class="swiper-container"> <!-- Additional required wrapper --> <div class="swiper-wrapper"> <!-- Slides --> <div class="swiper-slide"> </div> </div></div></div> <div id="popup-overlay"></div> </div>');
    $('#swiper_Frame').append('<div id="checkout-bar" class="checkout-bar"> <a href="#" onclick="goBack()" class="continue"> <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-left fa-w-14 fa-3x" style=" width: 10px; margin-right: 3px;"><path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" class=""></path></svg>Continue Shopping</a> <a href="#" id="checkout-bar-button">Checkout<span id="checkout-bar-total"></span></a> </div>');
        
    $('.sub-collapse').collapsible();
    

    
    
    $("#shopify-section-Mobile-Menu").panel({
      close: function(event, ui) {
        $('#swiper_Frame').removeClass('popup-open');
       //stopBodyScrolling2(false); 
      },
      open: function(event,ui) {
             var vpH = window.innerHeight;  
      $('#swiper_Frame').addClass('popup-open');
document.documentElement.style.height = vpH.toString() + "px";
$('#swiper_Frame')[0].style.height = vpH.toString() + "px";
//stopBodyScrolling2(true); 
      }
      
    });
    
    
    



   //disable page transition
    $.mobile.defaultPageTransition = 'fade';
  // $.mobile.page.prototype.options.domCache = true;
});
  
});



$(document).one("pagecontainershow", function (event,ui) {
   window.loaded = true; 
   function logLoaded2() {
   jQuery('#swiper_Frame').addClass('loaded');
      setTimeout(function() {
      jQuery('#swiper_Frame').addClass('loadedscroll');
        $(ui.toPage[0]).focus();
       },2500); 
    }

    (function listen2() {
        if (window.loaded) {
            logLoaded2();

        } else {
            window.setTimeout(listen2, 50);
        }
    })();  
});
